import { useTheme } from 'styled-components';

import { FeatureModuleEnum, JurisdictionsEnum } from '@libs/backend-common';
import { LoansIcon, ReferralsIcon, TransactionsIcon } from '@libs/components';
import { Environment } from '@libs/types';

import {
  ConvertIcon,
  DashboardActiveIcon,
  DashboardIcon,
  DepositIcon,
  ReferralsActiveIcon,
  TransactionsActiveIcon,
  WalletActiveIcon,
  WalletIcon,
  WithdrawIcon,
  // MessageQuestionIcon,
  FeesIcon,
  MarketplaceIcon,
  ActiveMarketplaceIcon,
  LoyaltyIcon,
  ActiveloyaltyIcon,
  ActiveFeesIcon,
  // FaqGe,
  FaqHome,
  InvestmentHome,
  // ActiveMessageQuestionIcon,
} from 'src/assets';
import { DashboardNavItemType } from 'src/constants';
import { useEnabledFeatures, useJurisdictionDetector } from 'src/hooks';

export const useDashboardNavItems = () => {
  const { colors } = useTheme();
  const iconBrandColor = colors.interactive.brandColor;
  const iconSecondaryColor = colors.text.secondary;

  const { currentJurisdiction } = useJurisdictionDetector();
  const isUaJurisdiction = currentJurisdiction === JurisdictionsEnum.UA;
  const isGeJurisdiction = currentJurisdiction === JurisdictionsEnum.GE;

  const { checkFeature, checkMultipleFeatures } = useEnabledFeatures();
  const isStakingAvailable = checkFeature(FeatureModuleEnum.STAKING);
  const isExchangeAvailable = checkFeature(
    FeatureModuleEnum.EXCHANGE
  ).isAvailable;
  const isDepositAvailable = checkMultipleFeatures([
    FeatureModuleEnum.BANK_WIRE_DEPOSIT,
    FeatureModuleEnum.CARD_DEPOSIT,
    FeatureModuleEnum.CASH_DEPOSIT,
    FeatureModuleEnum.CRYPTO_DEPOSIT,
  ]).isAvailable;
  const isWithdrawAvailable = checkMultipleFeatures([
    FeatureModuleEnum.BANK_WIRE_WITHDRAWAL,
    FeatureModuleEnum.CARD_WITHDRAWAL,
    FeatureModuleEnum.CASH_WITHDRAWAL,
    FeatureModuleEnum.CRYPTO_WITHDRAWAL,
  ]).isAvailable;

  const shouldShowWalletAndTransactions =
    isExchangeAvailable || isDepositAvailable || isWithdrawAvailable;

  const navigationItems: DashboardNavItemType[] = [
    {
      title: isUaJurisdiction ? 'common_crexswap' : 'common_dashboard',
      route: '/',
      icon: <DashboardIcon />,
      activeIcon: <DashboardActiveIcon />,
    },

    {
      shouldHide: !shouldShowWalletAndTransactions,
      title: 'common_wallet',
      route: '/wallet',
      icon: <WalletIcon />,
      activeIcon: <WalletActiveIcon />,
    },
    ...(isGeJurisdiction
      ? [
          {
            title: 'common_market',
            route: '/marketplace',
            icon: <MarketplaceIcon />,
            activeIcon: <ActiveMarketplaceIcon />,
          },
        ]
      : []),
    {
      shouldHide: !shouldShowWalletAndTransactions,
      title: 'common_transactions',
      route: '/transactions',
      icon: <TransactionsIcon />,
      activeIcon: <TransactionsActiveIcon />,
    },

    // {
    //   title: 'common_loans',
    //   route: '/quick-cash',
    //   icon: <LoansIcon />,
    //   activeIcon: <LoansIcon isActive={true} />,
    //   isNew: true,
    // },
  ];
  const navigationItemsSecondHalf: DashboardNavItemType[] = [
    ...(isGeJurisdiction
      ? [
          {
            title: 'common_referrals',
            route: '/referrals',
            icon: <ReferralsIcon />,
            activeIcon: <ReferralsActiveIcon />,
          },
        ]
      : []),
    ...(isGeJurisdiction
      ? [
          {
            title: 'common_loyalty_programm',
            route: '/loyalty',
            icon: <LoyaltyIcon />,
            activeIcon: <ActiveloyaltyIcon />,
            isNew: true,
          },
        ]
      : []),
  ];

  if (isUaJurisdiction) {
    navigationItems.splice(
      1,
      0,
      {
        shouldHide: !isExchangeAvailable,
        title: 'wallet_action_convert',
        route: '/convert',
        icon: <ConvertIcon />,
        activeIcon: <ConvertIcon color={iconBrandColor} />,
      },
      {
        shouldHide: !isDepositAvailable,
        title: 'dashboard_deposit',
        route: '/deposit',
        icon: <DepositIcon color={iconSecondaryColor} />,
        activeIcon: <DepositIcon />,
      },

      {
        shouldHide: !isWithdrawAvailable,
        title: 'dashboard_withdraw',
        route: '/withdraw',
        icon: <WithdrawIcon color={iconSecondaryColor} />,
        activeIcon: <WithdrawIcon />,
      }
    );
  }

  if (
    isStakingAvailable.isAvailable &&
    process.env.ENVIRONMENT === Environment.dev
  ) {
    navigationItems.push({
      title: 'common_staking',
      route: '/staking',
      icon: <LoansIcon />,
      activeIcon: <LoansIcon isActive={true} />,
      isNew: true,
    });
  }

  const supportNavigationItems = [
    {
      title: 'common_commissions',
      route: 'dashboard-fees',
      icon: <FeesIcon />,
      activeIcon: <ActiveFeesIcon />,
      isNew: true,
    },
    {
      title: 'common_faq',
      route: '/faq',
      icon: <FaqHome />,
      activeIcon: <FaqHome />,
      comingSoon: true,
    },
    {
      title: 'common_investment_calculator',
      route: '/buy-crypto',
      icon: <InvestmentHome />,
      activeIcon: <InvestmentHome />,
      comingSoon: true,
    },
  ];

  return { navigationItems, supportNavigationItems, navigationItemsSecondHalf };
};
